const LoadingSpinner = () => {
  return (
    // Match the hero section height (min-h-screen minus navbar pt-20) to prevent CLS
    <div
      className="flex items-center justify-center bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800"
      style={{ minHeight: 'calc(100vh - 5rem)' }}
    >
      <div className="relative">
        <div className="w-12 h-12 border-4 border-primary-100 border-t-primary-600 rounded-full animate-spin"></div>
        <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-r-primary-300 rounded-full animate-spin animation-delay-150"></div>
      </div>
    </div>
  )
}

export default LoadingSpinner